import { HttpHandler } from 'msw'

import { getSelfService } from './getSelfService'
import { reboot } from './reboot'
import { restart } from './restart'
import { updateSelfService } from './updateSelfService'

export const terminals: HttpHandler[] = [
    getSelfService,
    ...reboot,
    ...restart,
    updateSelfService,
]
